import {
    GLOBAL_LOGIN_USER,
    GLOBAL_LOGOUT_USER,
    SWITCH_PRODUCT_TYPE,
    SCALELINE_SET_PIXELS,
    GLOBAL_ENABLE_DEBUGING,
    GLOBAL_REFRESH_ADMIN_PROJECTS,
    ENDCAP_CONTEXT_SELECTED,
    GLOBAL_DRAWING_MODE_ADD,
    CHAMBER_CONTEXT_SELECTED,
    VIEWPORT_ADD_PRESSED_KEY,
    CONTEXT_ELEMENT_DESELECT,
    CONSTRAINTS_SET_DEFAULTS,
    APPTOOLBAR_RESET_APP_STATE,
    GLOBAL_DRAWING_MODE_REMOVE,
    APPTOOLBAR_SELECT_PIPE_TYPE,
    GLOBAL_PROJECT_TYPE_CHAMBER,
    PROJECTS_CRUD_RESTORE_STATE,
    VIEWPORT_DELETE_PRESSED_KEY,
    CHAMBER_ROW_CONTEXT_SELECTED,
    CHAMBER_BED_CONTEXT_SELECTED,
    APPTOOLBAR_SELECT_CHAMBER_TYPE,
    GLOBAL_DRAWING_MODE_INSERTA_TEE,
    DRAWINGTOOLBAR_SWITCH_TO_ADD_MODE,
    GLOBAL_DRAWING_MODE_INLET_MANIFOLD,
    GLOBAL_DRAWING_MODE_INSPECTION_PORT,
    GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD,
    DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE,
    DRAWINGTOOLBAR_SWITCH_TO_REMOVE_MODE,
    GLOBAL_DRAWING_SELECTOR_MODE_DEFAULT,
    CONTEXT_SELECTED_ELEMENT_TYPE_ENDCAP,
    CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER,
    DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE,
    CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_ROW,
    DRAWINGTOOLBAR_SWITCH_TO_INSERTA_TEE_MODE,
    CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_BED,
    DRAWINGTOOLBAR_SWITCH_TO_INLET_MANIFOLD_MODE,
    DRAWINGTOOLBAR_SWITCH_TO_INSPECTION_PORT_MODE,
    DRAWINGTOOLBAR_SWITCH_TO_OUTLET_MANIFOLD_MODE,
    DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE,
    RESTORED_STATE_BED_RENDERED,
    VIEWPORT_RESET_POSITION_SCALE,
    SYSTEM_START_GENERATION,
    CLEAN_END_GENERATION,
    CHAMBER_TYPE_ID_MC4500,
    HIDE_MC4500_DEPRECATION_ALERT,
    SUB_PROJECTS_CRUD_RESTORE_STATE,
    MULTIBED_RESET_APP_STATE,
    APPTOOLBAR_BASIC_RESET_APP_STATE,
    GLOBAL_CHAMBER_PLAN_SCALE_IN,
    GLOBAL_CHAMBER_PLAN_SCALE_MT,
    SET_PROJECT_URL_INVALID,
    SET_DISABLED_LAYER_DIALOG,
    FORM_ASSEMBLY_TOGGLE_MODAL,
    SIGN_UP_MODAL_TOGGLE,
    REP_CONTACT_TOGGLE_DIALOG,
    SALES_CONTACT_DIALOG, SYSTEM_NOTES_TOGGLE_DIALOG,
} from '../lib/types';
import dataset from "../lib/datasets/dataset.json";

const INIT_SCALE_PIXELS = 300;
const INIT_SCALE_VALUE = 60;
const INIT_PLAN_SCALE_INCHES = 1;
const INIT_CHAMBER_ROW_SPACING = 0.5;
const INIT_CHAMBER_ROW_SPACING_PIXELS =
    INIT_SCALE_PIXELS * ( INIT_CHAMBER_ROW_SPACING / INIT_SCALE_VALUE );

const initialState = {
  chamberType: dataset.elements.find((e) => e.id === 'R-902HD'),
  chamberEndCapType: dataset.elements.find((e) => e.id === 'R-902HD-Endcap'),
  enableDebuging: false,
  pressedKeys: new Set(),
  keysOfInterest: new Set(),
  contextSelectedElement: null,
  scaleValue: INIT_SCALE_VALUE,
  scalePixels: INIT_SCALE_PIXELS,
  planScaleInches: INIT_PLAN_SCALE_INCHES,
  planScaleMts: 350,
  drawingMode: GLOBAL_DRAWING_MODE_ADD,
  projectType: GLOBAL_PROJECT_TYPE_CHAMBER,
  chamberRowSpacing: INIT_CHAMBER_ROW_SPACING,
  enableTransparency: window._bridge !== undefined,
  chamberRowSpacingPixels: INIT_CHAMBER_ROW_SPACING_PIXELS,
  drawingSelectorMode: GLOBAL_DRAWING_SELECTOR_MODE_DEFAULT,
  isRestoringState: false,
  isRestoredProject: false,
  isSystemGenerated: false,
  isMC4500Deprecated: false,
  showMc4500DeprecationAlert: false,
  featureFlag: {
    byDate: ['2022-02-20', '2022-02-21', '2022-02-23'],
  },
  refreshAdminProjects: false,
  showProjectUrlInvalid: false,
  showDisableLayerLoginDialog: false,
    formAssemblyModalProps: {
        showFormsAssemblyModal: false,
        showCloseBtn: false,
        formUrl: "",
    },
    showSignUpModal: false,
    showRepContactDialog: false,
    showSalesInfoDialog: false,
    showTogglesDialog: false,
};

export default ( state = initialState, action ) => {

    switch (action.type) {
        case GLOBAL_ENABLE_DEBUGING:
            return {
                ...state,
                enableDebuging: true,
            };

        case GLOBAL_REFRESH_ADMIN_PROJECTS:
            return {
                ...state,
                refreshAdminProjects: action.payload,
            };

        case SWITCH_PRODUCT_TYPE:
            return {
                ...state,
                projectType: action.payload,
            };
        case GLOBAL_LOGIN_USER:
            return {
                ...state,
                user: action.payload,
            };

        case GLOBAL_LOGOUT_USER:
            return {
                ...state,
                user: initialState.user,
            };

        case APPTOOLBAR_SELECT_CHAMBER_TYPE:
            return {
                ...state,
                chamberType: action.payload.chamberType,
                chamberEndCapType: action.payload.chamberEndCapType,
            };

        case APPTOOLBAR_SELECT_PIPE_TYPE:
            return {
                ...state,
                pipeType: action.payload.pipeType,
            };

        case CONSTRAINTS_SET_DEFAULTS:
            const {
                chamberRowSpacing,
                chamberRowSpacingPixels,
            } = action.payload;

            return {
                ...state,
                chamberRowSpacing,
                chamberRowSpacingPixels,
            };

        case SCALELINE_SET_PIXELS:
            return {
                ...state,
                scalePixels: action.payload,
                chamberRowSpacingPixels:
                    action.payload * ( state.chamberRowSpacing / state.scaleValue ),
            };

        case DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE:
            return {
                ...state,
                scaleValue: action.payload,
                chamberRowSpacingPixels:
                    state.scalePixels * ( state.chamberRowSpacing / action.payload ),
            };

        case DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE:
            return {
                ...state,
                drawingSelectorMode: action.payload,
            };

        case DRAWINGTOOLBAR_SWITCH_TO_ADD_MODE:
            return {
                ...state,
                drawingMode: GLOBAL_DRAWING_MODE_ADD,
            };

        case DRAWINGTOOLBAR_SWITCH_TO_REMOVE_MODE:
            return {
                ...state,
                drawingMode: GLOBAL_DRAWING_MODE_REMOVE,
            };

        case DRAWINGTOOLBAR_SWITCH_TO_INSERTA_TEE_MODE:
            return {
                ...state,
                drawingMode: GLOBAL_DRAWING_MODE_INSERTA_TEE,
            };

        case DRAWINGTOOLBAR_SWITCH_TO_INSPECTION_PORT_MODE:
            return {
                ...state,
                drawingMode: GLOBAL_DRAWING_MODE_INSPECTION_PORT,
            };

        case DRAWINGTOOLBAR_SWITCH_TO_INLET_MANIFOLD_MODE:
            return {
                ...state,
                drawingMode: GLOBAL_DRAWING_MODE_INLET_MANIFOLD,
            };

        case DRAWINGTOOLBAR_SWITCH_TO_OUTLET_MANIFOLD_MODE:
            return {
                ...state,
                drawingMode: GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD,
            };

        case DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE:
            return {
                ...state,
                chamberRowSpacing: action.payload,
                chamberRowSpacingPixels:
                    state.scalePixels * ( action.payload / state.scaleValue ),
            };

        case VIEWPORT_ADD_PRESSED_KEY:
            let pka = new Set(state.pressedKeys);
            pka.add(action.payload);
            return {
                ...state,
                pressedKeys: pka,
            };

        case VIEWPORT_DELETE_PRESSED_KEY:
            let pkd = new Set(state.pressedKeys);
            pkd.delete(action.payload);
            return {
                ...state,
                pressedKeys: pkd,
            };

        case CHAMBER_ROW_CONTEXT_SELECTED:
            return {
                ...state,
                contextSelectedElement: {
                    type: CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_ROW,
                    row: action.payload,
                },
            };

        case CHAMBER_CONTEXT_SELECTED:
            return {
                ...state,
                contextSelectedElement: {
                    type: CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER,
                    row: action.payload.row,
                    col: action.payload.col,
                },
            };

        case ENDCAP_CONTEXT_SELECTED:
            return {
                ...state,
                contextSelectedElement: {
                    type: CONTEXT_SELECTED_ELEMENT_TYPE_ENDCAP,
                    row: action.payload.row,
                    position: action.payload.position,
                },
            };

        case CHAMBER_BED_CONTEXT_SELECTED:
            return {
                ...state,
                contextSelectedElement: {
                    type: CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_BED,
                },
            };

        case CONTEXT_ELEMENT_DESELECT:
            return {
                ...state,
                contextSelectedElement: initialState.contextSelectedElement,
            };

        case GLOBAL_CHAMBER_PLAN_SCALE_IN:
            return {
                ...state,
                planScaleInches: action.payload,
            };

        case GLOBAL_CHAMBER_PLAN_SCALE_MT:
            return {
                ...state,
                planScaleMts: action.payload,
            };

        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case MULTIBED_RESET_APP_STATE:
            return {
                ...initialState,
                projectType: state.projectType,
                chamberType: { ...state.chamberType },
                chamberEndCapType: { ...state.chamberEndCapType },
                chamberRowSpacing: state.chamberType.defaultSeparation,
                chamberRowSpacingPixels:
                    state.scalePixels *
                    ( state.chamberType.defaultSeparation / state.scaleValue ),
                pressedKeys: state.pressedKeys,
                keysOfInterest: state.keysOfInterest,
                scaleValue: state.scaleValue,
                planScaleInches: ( state.planScaleInches ) ? state.planScaleInches : INIT_PLAN_SCALE_INCHES,
                planScaleMts: ( state.planScaleMts ) ? state.planScaleMts : 350,
                scalePixels: state.scalePixels,
                drawingMode: state.drawingMode,
                drawingSelectorMode: state.drawingSelectorMode,
            };

        case APPTOOLBAR_RESET_APP_STATE:
            return {
                ...initialState,
                projectType: state.projectType,
                chamberType: { ...state.chamberType },
                chamberEndCapType: { ...state.chamberEndCapType },
                chamberRowSpacing: state.chamberType.defaultSeparation,
                chamberRowSpacingPixels:
                    initialState.scalePixels *
                    ( state.chamberType.defaultSeparation / initialState.scaleValue ),
            };

        case SUB_PROJECTS_CRUD_RESTORE_STATE:
            let srState = action.payload.globals;
            if (!( srState.pressedKeys instanceof Set )) {
                srState.pressedKeys = new Set(initialState.pressedKeys);
                srState.keysOfInterest = new Set(initialState.keysOfInterest);
            }
            return {
                ...srState,
                isRestoringState: true,
                isRestoredProject: true,
                projectType: srState.projectType || state.projectType,
                enableTransparency: initialState.enableTransparency,
                isMC4500Deprecated: initialState.isMC4500Deprecated,
                showMc4500DeprecationAlert: srState.chamberType.id === CHAMBER_TYPE_ID_MC4500 && initialState.isMC4500Deprecated,
                scaleValue: state.scaleValue,
                planScaleInches: ( state.planScaleInches ) ? state.planScaleInches : INIT_PLAN_SCALE_INCHES,
                planScaleMts: ( state.planScaleMts ) ? state.planScaleMts : 350,
                scalePixels: state.scalePixels,
                enableDebuging: initialState.enableDebuging,
            };

        case PROJECTS_CRUD_RESTORE_STATE:
            let rState = action.payload.globals;
            if (!( rState.pressedKeys instanceof Set )) {
                rState.pressedKeys = new Set(initialState.pressedKeys);
                rState.keysOfInterest = new Set(initialState.keysOfInterest);
            }

            let byDate = ["2022-01-01"];
            if (rState.featureFlag && rState.featureFlag.byDate) {
                byDate = rState.featureFlag.byDate;
            }


            return {
                ...rState,
                isRestoringState: true,
                isRestoredProject: true,
                projectType: rState.projectType || state.projectType,
                enableTransparency: initialState.enableTransparency,
                isMC4500Deprecated: initialState.isMC4500Deprecated,
                showMc4500DeprecationAlert: rState.chamberType.id === CHAMBER_TYPE_ID_MC4500 && initialState.isMC4500Deprecated,
                enableDebuging: initialState.enableDebuging,
                featureFlag: { byDate: byDate },
            };

        case RESTORED_STATE_BED_RENDERED:
            return {
                ...state,
                isRestoringState: false,
            };

        case VIEWPORT_RESET_POSITION_SCALE:
            return {
                ...state,
                scalePixels: INIT_SCALE_PIXELS,
                drawingMode: GLOBAL_DRAWING_MODE_ADD,
            };

        case SYSTEM_START_GENERATION:

            return {
                ...state,
                isSystemGenerated: true,
            };

        case CLEAN_END_GENERATION:
            return {
                ...state,
                isSystemGenerated: false,
            };


        case HIDE_MC4500_DEPRECATION_ALERT:
            return {
              ...state,
              showMc4500DeprecationAlert: false
            };

      case SET_PROJECT_URL_INVALID:
        return {
          ...state,
          showProjectUrlInvalid: action.payload
        };

      case SET_DISABLED_LAYER_DIALOG:
        return {
          ...state,
          showDisableLayerLoginDialog: action.payload
        };

        case FORM_ASSEMBLY_TOGGLE_MODAL:
            return {
                ...state,
                formAssemblyModalProps: {
                    showFormsAssemblyModal: action.payload.toggle,
                    showCloseBtn: action.payload.showCloseBtn,
                    formUrl: action.payload.formUrl,
                },
            };

        case SIGN_UP_MODAL_TOGGLE:
            return {
                ...state,
                showSignUpModal: action.payload.toggle,
            };

        case REP_CONTACT_TOGGLE_DIALOG:
            return {
                ...state,
                showRepContactDialog: action.payload.toggle,
            };
        case SALES_CONTACT_DIALOG:
            return {
                ...state,
                showSalesInfoDialog: action.payload,
            };

        case SYSTEM_NOTES_TOGGLE_DIALOG:
            return {
                ...state,
                showTogglesDialog: action.payload,
            };

      default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/globals-reducer.js